import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchTaskList = ({commit}) => {
    
    commit('toggleLoadingState', true)
    axios.get('/tasks/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        commit('setTaskList', {response: res.data.response})

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchTaskData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/tasks/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setTaskData', {response: res.data.response})   
            
        } else {
            commit('resetTaskData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitTaskData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
    axios.post('/tasks/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            if(!payload.group_task) {
                commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
                commit('closeTaskModal')
                dispatch('fetchTaskList')
            }                        
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitGroupTasks = ({commit, dispatch}, payload) => {
             
    payload.forEach(element => {
        element.group_task = true
        dispatch('submitTaskData', element)
    })

    setTimeout(() => {
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        commit('closeTaskGroupModal')
        dispatch('fetchTaskList')
    }, 1000);
}

export const deleteTaskData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/tasks/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            dispatch('fetchTaskList')            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/tasks/actions.js